import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';
import { toggleAttachmentErrorModal } from 'src/store/reducers/uiSlice';
import {
  attachementHasWrongFileTypes,
  attachmentOneOfFilesOverSizeLimit,
  attachmentsOverSizeLimit,
  hasTooManyAttachments,
} from 'src/util/attacehmentUtils';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import { getFormData, getFormDefinition, useAppDispatch } from '@helsenorge/refero';

const useValidateAttachments = (): {
  validateSave: () => false | string[];
  validateLive: () => false | string[];
  liveErrors: string[];
} => {
  const dispatch = useAppDispatch();
  const formDefinition = useAppSelector(state => getFormDefinition(state));
  const formData = useAppSelector(state => getFormData(state));
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const validateSave = (): false | string[] => {
    const errors = [
      attachmentOneOfFilesOverSizeLimit(formData?.Content, formDefinition?.Content, resources),
      hasTooManyAttachments(formData?.Content, resources),
      attachmentsOverSizeLimit(formData?.Content, resources),
      attachementHasWrongFileTypes(formData?.Content, resources),
    ]
      .flat()
      .filter(error => error !== false);
    if (errors.length > 0) {
      dispatch(
        toggleAttachmentErrorModal({
          show: true,
          text: errors,
        })
      );
      return errors;
    }

    return false;
  };
  const validateLive = (): false | string[] => {
    const errors = [hasTooManyAttachments(formData?.Content, resources), attachmentsOverSizeLimit(formData?.Content, resources)]
      .flat()
      .filter(error => error !== false);
    if (errors.length > 0) {
      dispatch(
        toggleAttachmentErrorModal({
          show: true,
          text: errors,
        })
      );
      return errors;
    }

    return false;
  };
  const errors = [hasTooManyAttachments(formData?.Content, resources), attachmentsOverSizeLimit(formData?.Content, resources)]
    .flat()
    .filter(error => error !== false);
  return { validateSave, validateLive, liveErrors: errors };
};

export default useValidateAttachments;
